// NOTE: some items are comments to be used in the future, for now they don't have in backend
import {
  HStack,
  View,
  VStack,
  Avatar,
  AvatarFallbackText
} from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";

import { ProfileController } from "./controller";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { HeaderStyleEnum } from "@repo/core/components/layout/CustomHeader/types";

function Profile() {
  const { back, isMobile, isWeb, selectedStore, user } = ProfileController();

  return (
    <PageScaffold
      onBackPress={back}
      onPressRightIcon={back}
      showBackButtonOnWeb
      rightWebLabel="Fechar"
      headerStyle={HeaderStyleEnum.grey}
      statusBarVariant={StatusBarVariantEnum.DEFAULT}
      bg="$backgroundLight50"
      isFullWidthContent
      title="Meu perfil"
    >
      <VStack w="$full" bg="$backgroundLight50" flex={1}>
        <VStack mx="$4" bg="$backgroundLight0" borderRadius="$2xl">
          <HStack
            px={isMobile ? "$4" : "$6"}
            py="$4"
            borderBottomWidth="$1"
            borderColor="$borderLight300"
          >
            <Text
              fontFamily="inter"
              fontWeight={700}
              fontSize="$md"
              color="$primary700"
            >
              Informações Pessoais
            </Text>
          </HStack>
          <VStack p={isMobile ? "$4" : "$6"} space="lg">
            <HStack alignItems="center" space="lg" mb="$1">
              <Avatar size={isMobile ? "lg" : "xl"}>
                <AvatarFallbackText>{user?.name}</AvatarFallbackText>
              </Avatar>
              <VStack flex={1} gap="$1">
                <Text
                  fontFamily="inter"
                  fontSize="$sm"
                  fontWeight={500}
                  color="$textLight600"
                >
                  Nome
                </Text>
                <Text fontSize="$md" fontWeight={600} color="$secondary800">
                  {user?.name}
                </Text>
              </VStack>
            </HStack>
            <View
              gap="$6"
              flexDirection={isMobile ? "column" : "row"}
              flexWrap="wrap"
            >
              {/* <VStack w={isMobile ? "$full" : "48%"} gap="$1">
                <Text
                  fontFamily="inter"
                  fontSize="$sm"
                  fontWeight={500}
                  color="$textLight600"
                >
                  Cargo
                </Text>
                <Text fontSize="$md" color="$secondary800">
                  [Gerente]
                </Text>
              </VStack> */}

              {/* <VStack w={isMobile ? "$full" : "48%"} gap="$1">
                <Text
                  fontFamily="inter"
                  fontSize="$sm"
                  fontWeight={500}
                  color="$textLight600"
                >
                  Permissão
                </Text>
                <Text fontSize="$md" color="$secondary800">
                  Administrador
                </Text>
              </VStack> */}

              <VStack w={isMobile ? "$full" : "48%"} gap="$1">
                <Text
                  fontFamily="inter"
                  fontSize="$sm"
                  fontWeight={500}
                  color="$textLight600"
                >
                  Loja
                </Text>
                <Text fontSize="$md" color="$secondary800">
                  {selectedStore?.descrLoja || ""}
                </Text>
              </VStack>

              {/*NOTE: hide for now don't have in backend*/}
              {/* <VStack w={isMobile ? "$full" : "48%"} gap="$1">
                <Text
                  fontFamily="inter"
                  fontSize="$sm"
                  fontWeight={500}
                  color="$textLight600"
                >
                  Ponto de Atendimento
                </Text>
                <Text fontSize="$md" color="$secondary800">
                  {user?.tokenData.lstPontosAtendimento}
                </Text>
              </VStack> */}
            </View>
          </VStack>
        </VStack>

        <VStack
          m="$4"
          bg="$backgroundLight0"
          borderRadius="$2xl"
          $md-minHeight="$30vh"
        >
          <HStack
            px={isMobile ? "$4" : "$6"}
            py="$4"
            borderBottomWidth="$1"
            borderColor="$borderLight300"
          >
            <Text
              fontFamily="inter"
              fontWeight={700}
              fontSize="$md"
              color="$primary700"
            >
              Minha conta
            </Text>
          </HStack>

          <View
            p={isMobile ? "$4" : "$6"}
            gap={isMobile ? 24 : 16}
            flexDirection={isMobile ? "column" : "row"}
          >
            <VStack flex={isWeb ? 1 : 0} space="sm">
              <Text
                fontSize="$sm"
                fontFamily="inter"
                fontWeight={500}
                color="$textLight600"
              >
                Usuário
              </Text>
              <Text
                fontSize="$md"
                fontFamily="inter"
                fontWeight={400}
                color="$textLight900"
              >
                {user?.username.toUpperCase()}
              </Text>
            </VStack>
            {/*NOTE: hide for now don't have in backend*/}
            {/* <HStack flex={isWeb ? 1 : 0} alignItems="center">
              <VStack flex={1} space="sm">
                <Text fontSize="$sm" fontWeight={500} color="$secondary400">
                  Senha
                </Text>
                <Text fontSize="$md" color="$secondary800">
                  ••••••••••
                </Text>
              </VStack>

              <Button
                height="$9"
                px="$4"
                text="Redefinir senha"
                variant="outline"
                leftIcon={{
                  name: "pen-square",
                  size: 16,
                  hoverColor: "$primary700"
                }}
                textStyle={{ fontSize: "$sm" }}
                onPress={() => push(ROUTES.changePassword)}
              />
            </HStack> */}
          </View>
        </VStack>
      </VStack>
    </PageScaffold>
  );
}
export default Profile;
